<template lang="pug">
  div(class="dynamic-toolbar")
    input(
      v-if="showFontSizeInput"
      type="number"
      :value="fontSize"
      @input="onInput"
      class="dynamic-toolbar__font-input"
      :class="inputClasses"
      data-toolbar="input"
    )
    div(
      v-if="showFontSizeInput"
      class="dynamic-toolbar__divider"
    )
    div(class="dynamic-toolbar__buttons")
      template(v-for="(action, idx) in actions")
        v-tooltip(
          v-if="action.tooltip"
          :key="idx"
          top
        )
          template(v-slot:activator="{ on }")
            e-toolbar-button(
              :action="action"
              :listeners="on"
            )
          span {{ action.tooltip }}
        e-toolbar-button(
          v-else
          :key="idx"
          :action="action"
        )
    div(class="dynamic-toolbar__divider")
    button(
      class="dynamic-toolbar__btn"
      data-toolbar="button"
      @click.prevent="$emit('delete')"
    )
      e-svg-icon(
        name="danger-trash"
        size="xmd"
      )
</template>

<script>
import { TYPES } from '~/modules/templates/constants/fields'
import EToolbarButton from '~/modules/templates/components/elements/e-toolbar-button'

export default {
  name: 'TemplatesDynamicToolbar',
  components: { EToolbarButton },
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    showFontSizeInput: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      hasInputError: false
    }
  },
  computed: {
    actions() {
      const actions = [
        {
          key: 'toolbar-duplicate-button',
          icon: 'plus-square-white',
          isActive: false,
          call: () => this.$emit('duplicate')
        },
        {
          key: 'toolbar-required-button',
          icon: this._.get(this.field, 'required', true) ? 'lock-danger' : 'lock',
          isActive: this._.get(this.field, 'required', true),
          tooltip: this._.get(this.field, 'required', true)
            ? this.$t('Click to make field optional')
            : this.$t('Click to make field required'),
          call: () => this.$emit('toggleRequired')
        }
        // {
        //   icon: 'copy-files',
        //   call: () => this.$emit('copy')
        // },
        // {
        //   icon: 'scissors',
        //   call: () => this.$emit('cut')
        // },
      ]
      if (this.field.type === TYPES.text || this.field.type === TYPES.autocomplete) {
        actions.unshift({
          key: 'toolbar-autocomplete-toggle-button',
          icon: 'personalcard',
          isActive: this.field.type === TYPES.autocomplete,
          call: () => this.$emit('toggleAutocomplete')
        })
      }

      return actions
    },
    inputClasses() {
      return {
        errored: this.hasInputError
      }
    }
  },
  methods: {
    onInput(event) {
      const fontSize = Number(event.target.value)
      this.$emit('update:fontSize', fontSize)
      if (fontSize < 8 || fontSize > 100) {
        this.hasInputError = true
        this.$emit('onError', this.hasInputError)
      } else {
        this.hasInputError = false
        this.$emit('onError', this.hasInputError)
      }
    }
  }
}
</script>

<style lang="scss">
.dynamic-toolbar {
  display: inline-flex;
  align-items: center;

  padding: 2px 12px;
  border-radius: 8px;
  background: rgba(3, 1, 2, 0.88);
  height: 36px;

  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: map-get($zIndexes, 'overAll');

  &.document-state {
    align-items: flex-start;
    gap: 8px;
    padding: 8px 12px;
    white-space: nowrap;
  }

  &__font-input {
    width: 36px;

    color: $white;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;

    outline: none;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &.errored {
      border-bottom: 2px solid $danger;
    }
  }

  &__divider {
    width: 2px;
    height: 20px;
    margin: 0 8px;
    background: #787878;
  }

  &__buttons {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
